import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface FiltrarS3000Request {
  file: File
  includeS3000?: boolean
  idPrevidenciario?: string
}

export function useFiltrarS3000() {
  const queryClient = useQueryClient()
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({ file, includeS3000, idPrevidenciario }: FiltrarS3000Request): Promise<DownloadFileResult> => {
      if (!file) {
        throw new Error('Arquivo é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const formData = new FormData()
      formData.append('file', file)

      if (typeof includeS3000 === 'boolean') {
        formData.append('include_s3000', String(includeS3000))
      }
      if (idPrevidenciario?.trim()) {
        formData.append('id_previdenciario', idPrevidenciario)
      }

      try {
        const response = await api.post<Blob>('/previdenciario/filtrar_s3000', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao filtrar S3000')
        }

        return toDownloadFileResult(response, 's3000-filtrado.zip')
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao filtrar S3000'))
      }
    },
    onSuccess: (_, request) => {
      if (request.idPrevidenciario?.trim()) {
        queryClient.invalidateQueries({ queryKey: ['previdenciario-detalhes', request.idPrevidenciario] })
      }
    }
  })
}
